import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { AppSettings } from '../config/app-settings.js';

export default function usePagination(items, pageSize) {
    const { t } = useTranslation();
    const { handleSetAlert } = useContext(AppSettings);
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
    const paginatedItems = items.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const changePage = (direction) => {
        if (direction === 0) {
            if(currentPage === 1){
                handleSetAlert('info', '', t('alerta.paginação.ini'));
                return;
            }
            setCurrentPage(p => p - 1);
        }else{
            if (currentPage === totalPages){
                handleSetAlert('info', '', t('alerta.paginação.fim'));
                return;
            }
            setCurrentPage(p => p + 1);
        }
    };

    const resetPage = () => setCurrentPage(1);

    return { currentPage, totalPages, paginatedItems, changePage, resetPage };
}